import {
  GET_DEVICE_TYPES_REQUEST,
  GET_DEVICE_TYPES_SUCCESS,
  GET_DEVICE_TYPES_FAILURE,
  GET_DEVICE_TYPES_TIMEOUT,

GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST,
GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS,
GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE,
GET_REPLACEMENT_BY_DEVICE_TYPE_TIMEOUT,
CLEAR_MESSAGE,

POST_CONFIRM_REPLACEMENT_REQUEST,
POST_CONFIRM_REPLACEMENT_SUCCESS,
POST_CONFIRM_REPLACEMENT_FAILURE,
POST_CONFIRM_REPLACEMENT_TIMEOUT,


GET_RMA_STATUS_REQUEST,
GET_RMA_STATUS_SUCCESS,
GET_RMA_STATUS_FAILURE,
GET_RMA_STATUS_TIMEOUT

} from './constants';
// import { isUserHomeowner } from './helper';

let initialState = {
  messageType: '',
  replacementDetails:null,
  DeviceTypes:null,
  stepOneConfirmed:false,
  stepTwoConfirmed:false,
  hems_status_code_for_device_enlighten_response:200,
  XSRFTOKEN:null,
  selectedDeviceType: null
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DEVICE_TYPES_SUCCESS:
      return {...state,DeviceTypes:action?.payload?.data,XSRFTOKEN:action?.payload?.XSRFTOKEN, hems_status_code_for_device_enlighten_response: action?.payload?.hems_status_code};
    case GET_DEVICE_TYPES_REQUEST:
            return {...state,DeviceTypes:[]};
    case GET_DEVICE_TYPES_FAILURE:
    case GET_DEVICE_TYPES_TIMEOUT:
      return {...state,DeviceTypes:[]};
    case GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST:
      return {...state,replacementDetails:null,stepOneConfirmed:true,messageType:"FETCHING_DEVICE_DETAILS_LOADER", selectedDeviceType: action?.payload?.deviceType};
    case GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS:
      return {...state,replacementDetails:action.payload,stepOneConfirmed:false,messageType:null};
    case GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE:
      return {...state,replacementDetails:null,stepOneConfirmed:false,messageType:action.payload};
    case GET_REPLACEMENT_BY_DEVICE_TYPE_TIMEOUT:
      return {...state,replacementDetails:null,stepOneConfirmed:false,messageType:action.payload};

    case POST_CONFIRM_REPLACEMENT_REQUEST:
      return {...state,confirmedReplacementDetails:null,stepTwoConfirmed:true,messageType:"INITIATING_REPLACEMENT_LOADER"};
    case POST_CONFIRM_REPLACEMENT_SUCCESS:
      return {...state,confirmedReplacementDetails:action.payload,stepTwoConfirmed:false};
    case POST_CONFIRM_REPLACEMENT_FAILURE:
      return {...state,confirmedReplacementDetails:null,stepTwoConfirmed:false,messageType:action.payload};
    case POST_CONFIRM_REPLACEMENT_TIMEOUT:
      return {...state,confirmedReplacementDetails:null,stepTwoConfirmed:false,messageType:action.payload};
    case GET_RMA_STATUS_SUCCESS:
      return {...state,messageType:action.payload.status};
    case GET_RMA_STATUS_FAILURE:
      return {...state,stepTwoConfirmed:false,messageType:action.payload};
    case GET_RMA_STATUS_TIMEOUT:
      return {...state,stepTwoConfirmed:false,messageType:action.payload};


    case CLEAR_MESSAGE:
      return {...state,messageType:null};
    default:
      return state;
  }
}

export default reducer;
